const config = require('../../yxlConfig.json');
if (config.env) {
  window.$liveApi = {
    "base_url": `https://api-live-${config.env}.xinli001.com`,
    "m_url": `https://m-${config.env}.xinli001.com`,
    "static_url": `https://static-${config.env}.xinli001.com`,
    "yiapi_url": `https://yiapi-${config.env}.xinli001.com`,
    "replayList_url": `https://static-${config.env}.xinli001.xin/live-broadcast/index.html#/replayList`,
    "liveList_url": `https://static-${config.env}.xinli001.xin/live-broadcast/index.html#/`,
    "m-xy_url": `//m-xy-${config.env}.xinli001.com`
  }
} else {
  window.$liveApi = {
    "base_url": `https://api-live.xinli001.com`,
    "m_url": "https://m.xinli001.com",
    "yiapi_url": "https://yiapi.xinli001.com",
    "replayList_url": `https://static.xinli001.xin/live-broadcast/index.html#/replayList`,
    "liveList_url": `https://static.xinli001.xin/live-broadcast/index.html#/`,
    "m-xy_url": `//m-xy.xinli001.com`
  }
}
